export default __webpack_public_path__ + "static/media/coffee.1d43de2d.svg";